import React, { useState, useEffect } from 'react'
import { Menu, Grid } from 'antd'
import PropTypes from 'prop-types'
import { useLocation, NavLink } from 'react-router-dom'
import { mpNavMenu, navMenu } from 'js/constant/nav-menu-plcp'
import styles from './styles'

const MenuPlcp = ({ menuDisplay, mp }) => {
  const location = useLocation()
  const [current, setCurrent] = useState()

  const { useBreakpoint } = Grid
  const { lg } = useBreakpoint()

  useEffect(() => {
    setCurrent(location.pathname)
  })

  const handleMenuClick = (e) => {
    setCurrent(e)
  }

  return (
    <div className={menuDisplay}>
      <Menu
        className={styles.navbar}
        mode={lg ? 'horizontal' : 'inline'}
        onClick={handleMenuClick}
        selectedKeys={[current]}
      >
        {mp
        ? mpNavMenu.map((link) => {
          const { id, key, title } = link
          return (
            <Menu.Item
              id={id}
              key={key}
            >
              <NavLink
                className={styles.menu_link}
                to={key}
              >{title}
              </NavLink>
            </Menu.Item>
          )
        })
      : navMenu.map((link) => {
        const { id, key, title } = link
        return (
          <Menu.Item
            id={id}
            key={key}
          >
            <NavLink
              className={styles.menu_link}
              to={key}
            >{title}
            </NavLink>
          </Menu.Item>
        )
      })}
      </Menu>
    </div>
  )
}

MenuPlcp.propTypes = {
  menuDisplay: PropTypes.string,
  mp: PropTypes.bool
}

export default MenuPlcp
